import styled, { css } from 'styled-components';

import { media } from '@savgroup-front-common/constants/shared';
import { opacify } from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { Button } from '../../atoms/button';
import { ChevronLeftIcon, ChevronRightIcon } from '../../protons/icons';
import { fontStyle } from '../../theme/helpers/fontStyle';

export const LeftArrowButton = styled(ChevronLeftIcon)`
  position: absolute;
  top: 50%;
  left: calc(-1 * ${spacing(2.5)});
  transform: translateY(-50%);
  cursor: pointer;
  color: ${({ theme }) => theme.colors.headingTextColor};
  left: 0;

  @media ${media.minWidth.md} {
    left: ${spacing(2.5)};
  }
`;

export const RightArrowButton = styled(ChevronRightIcon)`
  position: absolute;
  top: 50%;
  right: calc(-1 * ${spacing(2.5)});
  transform: translateY(-50%);
  cursor: pointer;
  color: ${({ theme }) => theme.colors.headingTextColor};
  right: 0;

  @media ${media.minWidth.md} {
    right: ${spacing(2.5)};
  }
`;

export const CalendarDayBlock = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  & *::first-letter {
    text-transform: uppercase;
  }
`;

export const CalendarDayName = styled.span`
  color: ${({ theme }) => theme.colors.mainTextColor};
  font-weight: ${fontWeight('bold')};
`;

export const CalendarDayDate = styled('p')`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;

const clickableMixin = ({ theme, clickable, active }: any) => {
  if (!clickable) {
    return css``;
  }

  return css`
    cursor: pointer;

    & {
      background-color: ${active
        ? theme.colors.primary
        : opacify(-0.9, theme.colors.primary)};
      color: ${active ? theme.colors.white : 'inherit'};
    }

    &:hover {
      background-color: ${active
        ? opacify(-0.3, theme.colors.primary)
        : opacify(-0.7, theme.colors.primary)};
    }
  `;
};

export const CalendarTimeBlock = styled.div<{
  $fullHeight?: boolean;
  clickable: boolean;
  active: boolean;
}>`
  border-radius: ${spacing('xs')};

  transition:
    background-color 300ms ease,
    color 300ms ease-out;

  color: ${({ theme }) => theme.colors.headingTextColor};
  padding: ${spacing(1.5)} ${spacing(2.5)};
  ${fontStyle('sm')};
  font-weight: ${fontWeight('medium')};
  line-height: 15px;
  text-align: center;

  height: ${({ $fullHeight }) => ($fullHeight ? '100%' : null)};

  margin-bottom: ${spacing('sm')};

  ${clickableMixin};

  & > div {
    @media ${media.minWidth.lg} {
      display: flex;
      justify-content: center;
      gap: ${spacing('xxs')};
    }
  }
`;

export const TimeSlotSelectorContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const $AppointmentCalendar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const AppointmentCalendarContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${spacing('xxl')};

  @media ${media.maxWidth.xs} {
    button[data-testid='previousScreenButton'],
    button[data-testid='nextScreenButton'] {
      height: ${spacing(5)};
      justify-content: flex-start;
      margin-top: ${spacing(5)};
    }
  }
`;

export const $ButtonWithMinWidth = styled(Button)`
  min-width: ${spacing('xxl')};
  flex-shrink: 0;
  position: relative;

  &:hover ${LeftArrowButton}, &:hover ${RightArrowButton} {
    opacity: 1;
  }

  &:disabled ${LeftArrowButton}, &:disabled ${RightArrowButton} {
    opacity: 0.35;
  }
`;
